export default __webpack_public_path__ + "static/card-image-2-dc9478c8e09ad7822a7f0928db8b1e01.png";